import { render, staticRenderFns } from "./Suspected.vue?vue&type=template&id=82f29302&"
import script from "./Suspected.vue?vue&type=script&lang=ts&"
export * from "./Suspected.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports